import { CHART_TYPES, WIDGET_TYPES } from '@/utils/consts';

import ColumnIcon from '@svgIcons/dashboard/widget_list_icons/column.svg';
import HorizontalIcon from '@svgIcons/dashboard/widget_list_icons/horizontal.svg';
import LineIcon from '@svgIcons/dashboard/widget_list_icons/line.svg';
import ComboIcon from '@svgIcons/dashboard/widget_list_icons/combo.svg';
import ScatterIcon from '@svgIcons/dashboard/widget_list_icons/scatter.svg';
import PieIcon from '@svgIcons/dashboard/widget_list_icons/pie.svg';
import DonutIcon from '@svgIcons/dashboard/widget_list_icons/donut.svg';
import WordCloudIcon from '@svgIcons/dashboard/widget_list_icons/word_cloud.svg';
import ColorClusterIcon from '@svgIcons/dashboard/widget_list_icons/color_clustering.svg';
import EmojiIcon from '@svgIcons/dashboard/widget_list_icons/emoji.svg';
import FunnelIcon from '@svgIcons/dashboard/widget_list_icons/funnel.svg';
import ChoroplethMapIcon from '@svgIcons/dashboard/widget_list_icons/choropleth_map.svg';
import FilterLabelIcon from '@svgIcons/dashboard/widget_list_icons/filter_label.svg';
import ABTestingIcon from '@svgIcons/dashboard/widget_list_icons/ab_testing.svg';
import AiInsightIcon from '@svgIcons/dashboard/widget_list_icons/ai_insight.svg';
import TableIcon from '@svgIcons/dashboard/widget_list_icons/table.svg';
import OverviewIcon from '@svgIcons/dashboard/widget_list_icons/overview.svg';
import CreativeIcon from '@svgIcons/dashboard/widget_list_icons/creative.svg';
import NotepadIcon from '@svgIcons/dashboard/widget_list_icons/notepad.svg';
import SingleMetricIcon from '@svgIcons/dashboard/widget_list_icons/single_metric.svg';
import GoalIcon from '@svgIcons/dashboard/widget_list_icons/goal.svg';
import AlarmIcon from '@svgIcons/dashboard/widget_list_icons/alarm.svg';
import SmallTableIcon from '@svgIcons/dashboard/widget_list_icons/small_table.svg';

const getGraphIcon = (widget) => {
    switch (widget.selectedGraphType || widget.subType) {
        case CHART_TYPES.BAR:
            return ColumnIcon;
        case CHART_TYPES.HORIZONTAL_BAR:
            return HorizontalIcon;
        case CHART_TYPES.LINE:
            return LineIcon;
        case CHART_TYPES.COMBO_CHART:
            return ComboIcon;
        case CHART_TYPES.SCATTER:
            return ScatterIcon;
        case CHART_TYPES.PIE:
            return PieIcon;
        case CHART_TYPES.DONUT:
            return DonutIcon;
        case CHART_TYPES.WORD_CLOUD:
            return WordCloudIcon;
        case CHART_TYPES.COLOR_CLUSTERING:
            return ColorClusterIcon;
        case CHART_TYPES.EMOJI_ANALYSIS:
            return EmojiIcon;
        case CHART_TYPES.FUNNEL:
            return FunnelIcon;
        case CHART_TYPES.CHOROPLETH_MAP:
            return ChoroplethMapIcon;
    }
};

const getFilterIcon = (widget) => {
    switch (widget.subType) {
        case 'label':
        case 'fieldValue':
            return FilterLabelIcon;

        default:
            return null;
    }
};

export const getIcon = (widget) => {
    const { subType } = widget;

    switch (widget.type) {
        case WIDGET_TYPES.PIVOT_TABLE:
        case WIDGET_TYPES.PIVOT_TABLE_ANALYTIC:
            return TableIcon;

        case WIDGET_TYPES.GRAPH:
            return getGraphIcon(widget);

        case WIDGET_TYPES.OVERVIEW:
            return OverviewIcon;

        case WIDGET_TYPES.CREATIVE:
            return CreativeIcon;

        case WIDGET_TYPES.NOTEPAD:
            if (subType === WIDGET_TYPES.AI_INSIGHT) {
                return AiInsightIcon;
            }
            return NotepadIcon;

        case WIDGET_TYPES.SINGLE_METRIC:
            return SingleMetricIcon;

        case WIDGET_TYPES.GOAL:
            return GoalIcon;

        case WIDGET_TYPES.ALARMS:
            return AlarmIcon;

        case WIDGET_TYPES.SMALL_TABLE:
            return SmallTableIcon;

        case WIDGET_TYPES.FILTER:
            return getFilterIcon(widget);

        case WIDGET_TYPES.AB_TESTING:
            return ABTestingIcon;
        default:
            return null;
    }
};
